var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__stroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.396,
    height: 26.395,
    viewBox: "0 0 26.396 26.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25172",
    "data-name": "Group 25172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12432",
    "data-name": "Rectangle 12432",
    width: 26.217,
    height: 25.936,
    transform: "translate(0 0.458)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M6.831,41.494a7.726,7.726,0,0,1,.4-2.45l-4.5-3.4a13.16,13.16,0,0,0,0,11.688l4.493-3.4a7.731,7.731,0,0,1-.4-2.439",
    transform: "translate(-1.081 -28.297)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M19.927,5.4a7.781,7.781,0,0,1,4.918,1.74L28.732,3.3A13.432,13.432,0,0,0,7.938,7.351l4.5,3.4A7.865,7.865,0,0,1,19.927,5.4",
    transform: "translate(-6.283)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M19.927,81.229a7.865,7.865,0,0,1-7.493-5.348l-4.5,3.4a13.333,13.333,0,0,0,11.989,7.351,12.809,12.809,0,0,0,8.7-3.289l-4.268-3.264a8.332,8.332,0,0,1-4.436,1.154",
    transform: "translate(-6.283 -60.234)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31192",
    "data-name": "Path 31192",
    d: "M78.209,54.763a10.82,10.82,0,0,0-.3-2.4H65.457v5.1h7.165a5.943,5.943,0,0,1-2.729,3.945l4.268,3.264a13.056,13.056,0,0,0,4.048-9.908",
    transform: "translate(-51.813 -41.566)",
    fill: "#4285f4",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.2c59d0ee6b7630dc9c25c4cef537cea9.svg";
export { ForwardRef as ReactComponent };